export default __webpack_public_path__ + "static/media/Buccaneers.5898b88e.png";